import Dispatcher from '../dispatcher';
import { TyreIndexExplanationLightboxActions } from '../constants/tyre_index_explanation_lightbox/tyre_index_explanation_lightbox_actions';

function openAction() {
    Dispatcher.handleTyreIndexExplanationLightboxAction({ type: TyreIndexExplanationLightboxActions.OPEN });
}

function closeAction() {
    Dispatcher.handleTyreIndexExplanationLightboxAction({ type: TyreIndexExplanationLightboxActions.CLOSE });
}

export {
    openAction,
    closeAction
};